import React from 'react';
import PropTypes from 'prop-types';
import { Grid, Typography } from '@metarouter-private/mr-mui';

import FieldValueView from 'app/audit-logs/AuditLogModal/AuditLogPanel/FieldValueView';

export default function AuditLogFieldRow({ field }) {
  return (
    <Grid container data-test-id="auditLogFieldRow" spacing={1}>
      <Grid item xs={4} data-test-id="auditLogFieldName">
        <Typography variant="body2">{field.label}</Typography>
      </Grid>
      <Grid item xs={4} data-test-id="auditLogFieldPrevious">
        <FieldValueView fieldValue={field.previous} />
      </Grid>
      <Grid item xs={4} data-test-id="auditLogFieldNew">
        <FieldValueView fieldValue={field.next} />
      </Grid>
    </Grid>
  );
}

AuditLogFieldRow.propTypes = {
  field: PropTypes.shape({
    label: PropTypes.string.isRequired,
    previous: PropTypes.object.isRequired,
    next: PropTypes.object.isRequired,
  }).isRequired,
};
